import { BrowserRouter } from "react-router-dom";
import { CssBaseline } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import EContainer from "./EnhancedComponents/EContainer";
import theme from "./EnhancedComponents/theme";

function App() {
  return (
    <ThemeProvider theme={theme} defaultMode="system">
      <CssBaseline enableColorScheme />
      <BrowserRouter>
        <EContainer />
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
